import { Features } from 'generated/featureDefinitions'
import { ImportPayrollResultModalDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { ImportResultModal } from 'modules/compensations/components/importResultModal'
import PayrollSummaryImportModal from 'modules/payroll_bundle/components/PayrollSummaryImport/PayrollSummaryImportModal'

interface Props {
  onFinish?: () => void
  onClose?: () => void
}

const ImportPayrollResultModal = ({ onFinish, onClose }: Props) => {
  const { company } = useCurrentSession()

  const { data, loading } = useQuery(ImportPayrollResultModalDocument, {
    variables: {
      companyId: company.id,
      featureAvailabilitiesIds: [Features.compensations_management],
    },
  })

  if (loading) {
    return <Loading />
  }

  const featureAvailabilities = data?.companies?.featureAvailabilitiesConnection?.nodes || []

  const hasCompensationsManagement = featureAvailabilities.some(
    (feature) => feature.id === Features.compensations_management && feature.available
  )

  if (hasCompensationsManagement) {
    return <ImportResultModal onClose={onClose} source="payroll_wrapper" />
  }

  return (
    <PayrollSummaryImportModal
      companyId={company.id}
      source="payroll_wrapper"
      onClose={onClose}
      onFinish={onFinish}
    />
  )
}

export default ImportPayrollResultModal
